import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import refundPolicy from '../../../assets/images/cancellation-policy.jpg'
import InnerBanner from '../../molecules/InnerBanner/InnerBanner'

const RefundPolicy = () => {
    return (
        <>

            <InnerBanner
                title="Refund Policy"
                // subtitle="The Europcar Story"
                imageSrc={refundPolicy}
                imageAlt="RefundPolicy"
            />
            <section className="policy-section section-padding">
                <Container>
                    <Row className='policy-section--row'>
                        <Col className="col-12 col">
                            <div className="mb-4">
                                <h3 className="h3 text-uppercase">Introduction</h3>
                                <p style={{ textAlign: 'justify' }}>
                                    At Europcar India, customer satisfaction is our top priority. We understand that cancellations may sometimes be necessary, and we strive to ensure a smooth and transparent refund process for all eligible transactions.
                                </p>

                            </div>
                            <div className="mb-4">
                                <h3 className="h3 text-uppercase">Refund Process & Timelines</h3>
                                <p style={{ textAlign: 'justify' }}>
                                    If your booking qualifies for a refund as per our <a href='/cancellation-policy'>Cancellation Policy</a>, the refund will be processed in accordance with the following terms:
                                </p>
                                <ul style={{ listStyle: 'disc', textAlign: 'justify' }}>
                                    <li><strong>Processing Time:</strong> Refunds will be initiated within 10 business days from the date of cancellation confirmation.</li>
                                    <li><strong>Mode of Refund:</strong> The refund will be credited to the original mode of payment used during booking.</li>
                                    <li><strong>Notification:</strong> You will receive an email confirmation once the refund has been successfully initiated from our end.</li>
                                </ul>
                            </div>

                            <div className='mb-4'>
                                <h3 className="h3 text-uppercase">Important Notes</h3>
                                <ul style={{ listStyle: 'disc', textAlign: 'justify' }}>
                                    <li>Refund timelines may vary depending on the payment provider or bank policies.</li>
                                    <li>In case of payment failures or delays beyond 10 business days, please contact our support team for assistance.</li>
                                    <li>Refunds are subject to applicable cancellation charges as outlined in our Cancellation Policy.</li>
                                    <li>Any promotional discounts or coupon codes used during booking will not be reissued or refunded.</li>
                                    <li>Refunds are not applicable in case of:</li>
                                    <ul style={{ listStyle: 'disc', textAlign: 'justify' }}>
                                        <li>No-shows by the user.</li>
                                        <li>Bookings cancelled less than 6 hours before the pickup time.</li>
                                        <li>Partially used bookings or early return of the vehicle.</li>
                                    </ul>
                                </ul>

                            </div>
                            <div className='mb-4'>
                                <h3 className="h3 text-uppercase">Need Help?</h3>
                                <p>If you have any questions or face any issues related to your refund, feel free to contact us at:</p>
                                <ul style={{ listStyle: 'disc', textAlign: 'justify' }}>
                                    <li><a href="tel:+918421555659">+91 8421555659 </a></li>
                                    <li><a href="mailto:car.reservations@europcar.in">car.reservations@europcar.in</a></li>
                                </ul>
                                <p>Our team will be happy to assist you throughout the refund process.
                                </p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>


        </>
    )
}

export default RefundPolicy;
